<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
      <div class="bg-white page-border">
      <!--page body contant -->
        <!-- header  -->
        <div class="row row-replace add-m-b">
            <div class="col-md-6 col-p h5">DASHBOARD / ADMIN ATTENDANCE </div>
            <div class="col-md-6 top-corner-items col-p"> 
            </div>
        </div>


<!--search fields -->
        <div class="row row-replace add-m-b">
            <div class="col-md-12 col-p">
<fieldset>
    <legend class="h6">Filter<i class="fa fa-filter"></i></legend>

                <form>
                    <div class="form-row">
                        <div class="col-md-1 mb-1 form-group">
                          Search By:
                         </div>
                        <div class="col-md-3 mb-3 form-group">
                           <input type="text" class="form-control"  placeholder="Employee Name"  required="">
                        </div>
                        <div class="col-md-3 mb-3">
                            <input type="text" class="form-control"  placeholder="Month"  required="">
                        </div>
                        <div class="col-md-3 mb-3">
                            <input type="text" class="form-control"  placeholder="Year"  required="">
                        </div>
                        <div class="col-md-2 mb-2">
                            <button class="btn btn-sm btn-primary"> Search</button>
                        </div>
                    </div>
                </form>
            </fieldset>
            </div>
         
        </div>
    
<!--end search fields-->

        <div class="row row-replace">
            <div class="col-12 col-pn">
               <div class="card card-table flex-fill">
                  <div class="card-body">
                     <div class="table-responsive table-h">
                        <table class="table custom-table table-nowrap mb-0 table-min text-center row-align-p">
                           <thead>
                              <tr>
                                 <th>Employee</th>
                                 <th>1</th>
                                 <th>2</th>
                                 <th>3</th>
                                 <th>4</th>
                                 <th>5</th>
                                 <th>6</th>
                                 <th>7</th>
                                 <th>8</th>
                                 <th>9</th>
                                 <th>10</th>
                                 <th>11</th>
                                 <th>12</th>
                                 <th>13</th>
                                 <th>14</th>
                                 <th>15</th>
                                 <th>16</th>
                                 <th>17</th>
                                 <th>18</th>
                                 <th>19</th>
                                 <th>20</th>
                                 <th>22</th>
                                 <th>23</th>
                                 <th>24</th>
                                 <th>25</th>
                                 <th>26</th>
                                 <th>27</th>
                                 <th>28</th>
                                 <th>29</th>
                                 <th>30</th>
                                 <th>31</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr>
                                 <td>
                                    <h2 class="table-avatar">
                                       <a class="avatar avatar-xs" href="profile"><img alt="" src="public/img/profiles/avatar-09.jpg"></a>
                                       <a href="profile">John Doe</a>
                                    </h2>
                                 </td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-warning">L</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-danger">A</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-warning">L</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-danger">A</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-warning">L</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-danger">A</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-warning">L</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-danger">A</p></td>
                                 <td><p class="text-success">P</p></td>
                                 <td><p class="text-success">P</p></td>
                              </tr>
                              <tr>
                                <td>
                                   <h2 class="table-avatar">
                                      <a class="avatar avatar-xs" href="profile"><img alt="" src="public/img/profiles/avatar-09.jpg"></a>
                                      <a href="profile">Ravi kumar Singh</a>
                                   </h2>
                                </td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-warning">L</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-danger">A</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-warning">L</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-danger">A</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-warning">L</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-warning">L</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-danger">A</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-warning">L</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-danger">A</p></td>
                                <td><p class="text-success">P</p></td>
                                <td><p class="text-success">P</p></td>
                             </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!--end table -->

         <!--records show status row-->
         <div class="row row-replace">
            <div class="col-12 col-pn">
            <div class="card-table flex-fill">
                    <div class="card-body">
                        <div class="row">
                        <div class="col">            
                            <label>Showing 0 to 0 of 0 entries</label>        
                        </div>
                        <div class="col">  
                            <label class="float-right">       
                                <ul class="pagination">
                                    <li class="page-item previous disabled">
                                        <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                    </li>
                                    <li class="page-item active">
                                        <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                                    </li>
                                    <li class="page-item next disabled"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0" class="page-link">Next</a>
                                    </li>
                                </ul>
                            </label>   
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <!--end body container-->
       
     
      </div>
    </div>
  </div>

  


<!-- Attendance modal -->
  <div id="add-EmployeeAttendance" class="modal custom-modal fade" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-header">
             <h5 class="modal-title">Attendance</h5>
             <button type="button" class="close" data-dismiss="modal" aria-label="Close">
             <span aria-hidden="true">×</span>
             </button>
          </div>
          <div class="modal-body">
             <div class="row">
                <div class="col-md-6">
                   <div class="card punch-status">
                      <div class="card-body">
                         <h5 class="card-title">Timesheet <small class="text-muted">11 Mar 2019</small></h5>
                         <div class="punch-det">
                            <h6>Punch In at</h6>
                            <p>Wed, 11th Mar 2019 10.00 AM</p>
                         </div>
                         <div class="punch-info">
                            <div class="punch-hours">
                               <span>3.45 hrs</span>
                            </div>
                         </div>
                         <div class="punch-det">
                            <h6>Punch Out at</h6>
                            <p>Wed, 20th Feb 2019 9.00 PM</p>
                         </div>
                         <div class="statistics">
                            <div class="row">
                               <div class="col-md-6 col-6 text-center">
                                  <div class="stats-box">
                                     <p>Break</p>
                                     <h6>1.21 hrs</h6>
                                  </div>
                               </div>
                               <div class="col-md-6 col-6 text-center">
                                  <div class="stats-box">
                                     <p>Overtime</p>
                                     <h6>3 hrs</h6>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="col-md-6">
                   <div class="card recent-activity">
                      <div class="card-body">
                         <h5 class="card-title">Activity</h5>
                         <ul class="res-activity-list">
                            <li>
                               <p class="mb-0">Punch In at</p>
                               <p class="res-activity-time">
                                  <i class="fa fa-clock-o"></i>
                                  10.00 AM.
                               </p>
                            </li>
                            <li>
                               <p class="mb-0">Punch Out at</p>
                               <p class="res-activity-time">
                                  <i class="fa fa-clock-o"></i>
                                  11.00 AM.
                               </p>
                            </li>
                            <li>
                               <p class="mb-0">Punch In at</p>
                               <p class="res-activity-time">
                                  <i class="fa fa-clock-o"></i>
                                  11.15 AM.
                               </p>
                            </li>
                            <li>
                               <p class="mb-0">Punch Out at</p>
                               <p class="res-activity-time">
                                  <i class="fa fa-clock-o"></i>
                                  1.30 PM.
                               </p>
                            </li>
                            <li>
                               <p class="mb-0">Punch In at</p>
                               <p class="res-activity-time">
                                  <i class="fa fa-clock-o"></i>
                                  2.00 PM.
                               </p>
                            </li>
                            <li>
                               <p class="mb-0">Punch Out at</p>
                               <p class="res-activity-time">
                                  <i class="fa fa-clock-o"></i>
                                  7.30 PM.
                               </p>
                            </li>
                         </ul>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
 </div>
 <!--end third model-->


